import { Flex } from '@fluentui/react-northstar';
import React from 'react';

export const BackendUpdating = () => {
  return (
    <div className="h-screen flex justify-center content-center">
      <Flex gap="gap.small" hAlign="center" vAlign="center">
        <Flex column={true} hAlign="center" vAlign="center">
          <img src="https://signup.tikit.ai/images/tikit-logo-stacked.png" width="300" />          
          <h2 className="font-bold text-2xl mb-3 mt-12">Oops, something isn't quite right.</h2>
          <div>We might be making feature updates or wokring to restore service as soon as possible.</div>
          <div>We don't expect this to take long, if you have an immediate question please reach out to us at <a href="mailto:help@cireson.com" style={{ "textDecoration": "underline"}}>help@cireson.com</a>.</div>
          <br /><br />
          <a href="https://status.tikit.ai/" style={{ "textDecoration": "underline" }}>Get latest service status & updates here</a>
        </Flex>
      </Flex>
    </div>
  );
};
